import React from 'react';
import { SvgIconProps } from '@mui/material';

export const NoTrackableDataIconBig: React.FC<SvgIconProps> = (props) => (
    <svg
        width="96"
        height="90"
        viewBox="0 0 96 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M44.3001 88.2571C35.3676 88.2571 26.6631 85.3734 19.4368 80.02C12.2106 74.6667 6.83137 67.1186 4.07059 58.4562C1.3098 49.7937 1.3098 40.4634 4.07059 31.8009C6.83137 23.1385 12.2106 15.5904 19.4368 10.2371C26.6631 4.8837 35.3676 2 44.3001 2C53.2326 2 61.9354 4.8837 69.1633 10.2371C76.3895 15.5904 81.7688 23.1385 84.5295 31.8009C87.2903 40.4634 87.2903 49.7937 84.5295 58.4562M78.374 49.9215L84.2481 59.5058L93.648 52.3168M53.7 30.7529C53.7 36.0464 49.4917 40.3372 44.3001 40.3372C39.1084 40.3372 34.9001 36.0464 34.9001 30.7529C34.9001 25.4594 39.1084 21.1686 44.3001 21.1686C49.4917 21.1686 53.7 25.4594 53.7 30.7529ZM35.8948 49.9215H52.7037C54.2159 49.9215 54.9712 49.9215 55.6473 50.0315C57.9875 50.4132 60.0108 51.7572 61.1446 53.6802C61.4713 54.2365 61.7106 54.8964 62.1894 56.2178C62.7635 57.8044 63.0514 58.5985 63.0902 59.2389C63.2277 61.4967 61.6314 63.5362 59.262 64.1297C58.5908 64.298 57.6819 64.298 55.8656 64.298H32.7313C30.915 64.298 30.0061 64.298 29.3349 64.1297C26.9655 63.5362 25.3692 61.4967 25.5067 59.2389C25.5455 58.5985 25.8334 57.806 26.4075 56.2178C26.8863 54.8964 27.124 54.2365 27.4523 53.6802C28.5861 51.7572 30.6094 50.4132 32.9496 50.0315C33.6257 49.9215 34.381 49.9215 35.8932 49.9215H35.8948Z"
            stroke="currentColor"
            strokeWidth="3.07293"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default NoTrackableDataIconBig;
